import api from '../../api/api'
import url from '../../api/env'
import Utils from '../../utils/Utils'

const read = async (filterName, pageNumber, excludeChars = true, sort_type = 'desc') =>
  api  
    .get(excludeChars ? `${url.stage.storeTurnsOpen}?sort_type=${sort_type}&per_page=${pageNumber}&name=%${encodeURIComponent(filterName)}%` : encodeURI(`${url.stage.storeTurnsOpen}?per_page=${pageNumber}&name=%${filterName}%`), {})
    .then(res => res)
    .catch(err => err)

const storeNextPage = async urlNextPage =>
  api
    .get(`${urlNextPage}`, {})
    .then(res => res)
    .catch(err => err)

const closeStoreTurn = async (id, data) =>
  api
    .put(`${url.stage.storeTurnsClose}/${id}`, data)
    .then(res => res)
    .catch(err => (err === 'Unauthenticated.' ? Utils.clearFoAuthError() : console.log(err))) 

const readTurns = async storeId =>
  api
    .get(`${url.stage.Turns}?store_id=${storeId}`, {})
    .then(res => res)
    .catch(err => err)

const saveTurns = async data =>
  api
    .post(url.stage.Turns, data)
    .then(res => res)
    .catch(err => err)

const removeTurns = async turnId =>
  api
    .remove(`${url.stage.Turns}/${turnId}`, {})
    .then(res => res)
    .catch(err => err)

const updateTurns = async (turnId, data) =>
  api
    .put(`${url.stage.Turns}/${turnId}`, data)
    .then(res => res)
    .catch(err => err)

export default {
  read,
  closeStoreTurn,
  storeNextPage,  
  readTurns,
  saveTurns,
  removeTurns,
  updateTurns,
}
